import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';




@Component({
  selector: 'app-registro-alarmas',
  templateUrl: './registro-alarmas.component.html',
  styleUrls: ['./registro-alarmas.component.css']
})
export class RegistroAlarmasComponent implements OnInit {
  
  DEBUG: boolean = true;
  arrayUser:any;

  constructor(
    @ Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    console.log("registro alarmas: ")
    console.log(this.data);
    this.getRegistroAlarmas();
  }
 
  getRegistroAlarmas() {
    // RECUPERAMOS LOS DATOS DE LAS ALARMAS DE AWS
    // GET
      console.log('[getAlarm]  GET ALARMAS: ' + this.data.userid);
    this.asyncMethodgetRegistroAlarmas(this.data.userid, 1000, 9999);
  
    }
  
    async asyncMethodgetRegistroAlarmas(disp: string, timeini: number, timefin: number){
    // GUARDAMOS LOS DATOS DE LAS ALARMAS DE AWS 
  
  
    }

}
